import * as yup from 'yup';

export type MimeSenderNameType = {
  source:
    | 'azure_storage'
    | 'box'
    | 'dropbox'
    | 'evernote'
    | 'gmail'
    | 'googledrive'
    | 'needldrive'
    | 'onedrive'
    | 'onenote'
    | 'outlook'
    | 'sharepoint'
    | 'slack'
    | 'teams'
    | 'telegram'
    | 'whatsapp';
  sourceDetails: unknown;
};

export const mimeSenderName = ({
  source,
  sourceDetails,
}: MimeSenderNameType) => {
  switch (source) {
    case 'dropbox':
    case 'googledrive':
    case 'box':
    case 'azure_storage':
    case 'sharepoint':
    case 'onedrive': {
      const details = yup
        .object({
          'Sender Name': yup.string().optional(),
          'Folder Name': yup.string().optional(),
        })
        .validateSync(sourceDetails);

      return (details?.['Sender Name'] || details?.['Folder Name']) ?? null;
    }
    case 'outlook':
    case 'gmail': {
      const details = yup
        .object({
          'Sender Name': yup.string().optional(),
          'Sender ID': yup.string().optional(),
        })
        .validateSync(sourceDetails);

      return (details?.['Sender Name'] || details?.['Sender ID']) ?? null;
    }
    case 'evernote':
    case 'onenote': {
      const details = yup
        .object({
          'Note Name': yup.string().optional(),
          'Notebook Name': yup.string().optional(),
        })
        .validateSync(sourceDetails);

      return (details?.['Note Name'] || details?.['Notebook Name']) ?? null;
    }
    case 'whatsapp':
    case 'telegram': {
      const details = yup
        .object({
          'Sender Group': yup.string().optional(),
          'Sender Name': yup.string().optional(),
        })
        .validateSync(sourceDetails);

      return (details?.['Sender Group'] || details?.['Sender Name']) ?? null;
    }
    case 'slack':
    case 'teams': {
      const details = yup
        .object({
          'Sender Name': yup.string().optional(),
          'Sender Group': yup.string().optional(),
          team: yup.string().optional(),
        })
        .validateSync(sourceDetails);

      return (
        (details?.['Sender Name'] ||
          details?.['Sender Group'] ||
          details?.team) ??
        null
      );
    }
    case 'needldrive': {
      const details = yup
        .object({
          'Sender Name': yup.string().optional(),
          'Folder Name': yup.string().optional(),
        })
        .validateSync(sourceDetails);

      return (details?.['Sender Name'] || details?.['Folder Name']) ?? null;
    }
    default:
      return null;
  }
};
